// extracted by mini-css-extract-plugin
export var body = "_ld-0";
export var sectionHeader = "_ld-4";
export var shortcutColumns = "_ld-2";
export var shortcutList = "_ld-1";
export var shortcutSection = "_ld-3";